import React from "react";
export function Footer() {
  return <footer className="bg-[#0a1a40] px-4 pb-32 pt-12 text-center sm:px-6 md:pb-12" data-id="element-182" data-mp="19ivlq3plplne">
      <div className="mx-auto max-w-3xl" data-id="element-183" data-mp="206rhbd2wfkqn">
        <p className="font-display text-lg font-bold text-white" data-id="element-184" data-mp="2f4tm1qlo2c9h">PEDIATRIC ARTICULATION CLINICAL BLUEPRINT™</p>
        <p className="mt-2 text-sm text-white/75" data-id="element-185" data-mp="2a607rvyk2h89">
          Educational resources for pediatric speech sound planning and documentation.
        </p>
        <p className="mt-6 text-xs leading-relaxed text-white/60" data-id="element-186" data-mp="1mgnzcyb1yd70">
          This product is educational in nature and does not replace individualized assessment, professional judgment,
          specialist training, or applicable professional standards.
        </p>
        <p className="mt-4 text-xs text-white/60" data-id="element-187" data-mp="1rez9zb968rqa">© 2026 Pediatric Articulation Clinical Blueprint™. All rights reserved.</p>
      </div>
    </footer>;
}